import React, { useState, useEffect  } from 'react';
import { Helmet } from 'react-helmet';
import { message, Spin, Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/Dashboard.css';
import NavBar from '../components/AnnualLeaveRequest/NavBar';
import AnnualLeaveRequestContent from '../components/AnnualLeaveRequest/AnnualLeaveRequestContent';
import { API_URL, API_username, API_password } from '../utils/api';

function AnnualLeaveRequest() {
	const location = useLocation();
    const isExist = location.state?.isExist; 
	useEffect(() => {
		
	}, []);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
    const [requestData, setRequestData] = useState({
        Action: "create",
        UID: "",
        StartDate: "",
        EndDate: "",
        AttachedFiles: [],
    });
		
	const sendRequest = () => {
		if(requestData.StartDate === "" || requestData.EndDate === "") {
			message.info('Заполните период отпуска корректно!');
		} else if(requestData.AttachedFiles.length === 0) {
			message.info('Прикрепление подписанного непосредственным руководителем скана заявления обязательно!');
		} else {
			setLoading(true);
			let apiUrl = `${API_URL}/lk?method=ManageAnnualLeaveRequest&inbody=1`;
			let sessionId = localStorage.getItem("SessionId")
			fetch(apiUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
					'sessionid': sessionId
				},
				body: JSON.stringify(requestData)
			})
			.then(response => {
				if (response.status === 200) {
					message.success('Заявление успешно отправлено!');
					navigate('/requests');
					return "success";
				} else if (response.status === 202) {
					message.error('Сервер на данный момент перегружен!');
					return "error";
				} else if (response.status === 404) {
					if(response.statusText === 'Session not found') {
						message.error('Сессия не найдена, авторизуйтесь заново!');
						navigate('/logout');
					} else {
						message.error('Метод не найден!');
					}
					return "error";
				} else {
					message.error('Произошла ошибка при отправке запроса!');
					return "error";
				}
			});
		}
	}

	return (
		<div>
			<Helmet>
				<title>Подача заявления на ежегодный отпуск - Личный кабинет Enter Engineering</title>
			</Helmet>			
			<div className='dashboard'>
				<NavBar />
				<div className='dashboard-content' style={{ padding: 0 }}>
					{loading && (<div className='loader-container'>
						<Spin size="large"/>
					</div>)}
					<div className='manage-request-content'>
						<AnnualLeaveRequestContent requestData={requestData} setRequestData={setRequestData} isExist={isExist} />
						<Button onClick={() => sendRequest()} style={{ marginTop: '8px' }} disabled={isExist}>Отправить</Button>
						<Button onClick={() => navigate('/requests')} style={{ marginLeft: '8px' }}>Назад</Button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default AnnualLeaveRequest;
